import { render, staticRenderFns } from "./PickFileDialog.vue?vue&type=template&id=2b0b161c&"
import script from "./PickFileDialog.vue?vue&type=script&lang=js&"
export * from "./PickFileDialog.vue?vue&type=script&lang=js&"
import style0 from "./PickFileDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports